<template>
  <div id="Client" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 bg-color-white pl5 pr5 fixed-t b-s-2">
      <div class="col-12 lh40 bg-color-white pl5 pr5">
          <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-muted"></i></div>
          <div class="col-6 t-c color-white">-</div>
          <div class="col-3 t-r f26"><i class="iconfont icon-gengduo color-muted"></i></div>
      </div>
      
      <div class="col-12 bg-color-white pl20 pr20 pb20">
        <div class="col-12 t-c">
          <img src="../../assets/store_logo.png" alt="" class="w10 r5">
        </div>
        <div class="col-12 t-c pt10 fw f18 uppercase el1">
          {{ pageData.enterprise_name }}
        </div>
        <div class="col-12 t-c pt5 f14 uppercase">
          RIF: {{ pageData.license_type }}-{{ pageData.license }} <span class="bg-color-warning color-white f12 pt1 pb1 pl3 pr3 r5" v-if="pageData.is_specials == 1">C.E</span>
        </div>
      </div>
    </div>
    <div class="col-12 h22"></div>
    <div class="col-12 pl20 pr20 pt8 pb8 f14 t-c" @click="change_tec()">
      <i class="iconfont icon-type-of-work-managem f20 color-primary"></i> Técnico: <span v-if="pageData.tec_name">{{pageData.tec_name}}</span> <span v-else>Nadie</span>
    </div>
    <div class="col-12">
      <div class="col-12 color-black pl5 pr5 mb5 t-c" v-for="(extension, extension_i) in extension_list" v-bind:key="extension_i">
        <div class="col-12 bg-color-white p5 r5" @click="go_ext(extension.extid)">
          <div class="col-2 lh50 br1">
            <i class="iconfont icon-diannao f30 color-primary"></i>
          </div>
          <div class="col-9 pl10 f16 t-l pt10">
              <div class="col-12 uppercase mb5"> <span class="fw">{{extension.extension_name}}</span>  - <span class="color-success f14">[ {{ extension.pos_ver }} ]</span> </div>
              <div class="col-12 f14 color-black">Vencimiento: <span  class="fw" :class="[extension.exp_day <= 0?'color-danger':'color-success']">{{extension.exp_day}}</span> días</div>
              <div class="col-12 f12 color-muted">Sincronización: {{extension.update_time}}</div>
          </div>
          <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
        </div>
      </div>
    </div>
    <div class="col-12 h5"></div>
    <div ref="app_foot" class="col-12 fixed-b color-white f14 bg-color1 lh50 h5 uppercase" v-if="pageData.tec_name == $store.state.account.user">
      <div class="col-6 bg-color-success t-c f12" @click="go_act(1)"><i class="iconfont icon-diannao color-white f22"></i> Agregar CAJA</div>
      <div class="col-6 bg-color-primary t-c f12" @click="go_act(2)"><i class="iconfont icon-jinrudianpu color-white f22"></i> agregar sucursal</div>
    </div>
    <div ref="app_foot" class="col-12 fixed-b color-white f14 bg-color1 lh50 h5 uppercase" v-else-if="pageData.tec_id == 0">
      <div class="col-12 bg-color-warning t-c f12" v-if="pageData.log_find == 1"><i class="iconfont icon-shalou color-white f22"></i> La solicitud se está procesando</div>
      <div class="col-12 bg-color-warning t-c f12" @click="get_it_confim()" v-else><i class="iconfont icon-31wode color-white f22"></i> Este es mi cliente</div>
    </div>
    <div class="col-12 fixed-b h10 bg-color-white b-s-1 pt20 pb10" v-if="is_change_tec">
      <div class="col-12 t-c lh50">
       <span class="pr5">Tecnico : </span> <input type="text" class="bg-color-white b1 pl5 pr5 w8 pt5 pb5 t-c" v-model="new_tec">  <span class="bg-color-success color-white pt5 pb5 pl15 pr15 r5" @click="change_tec_now()">Cambiar</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Client',
  data () {
    return {
      appid: '',
      pageData: {},
      extension_list: [],
      is_change_tec: false,
      new_tec: ''
    }
  },
  created: function () {
    this.appid = this.$route.query.appid;
    this.get_pageData();
  },
  methods: {
    get_pageData() {
      var post_data = {}
      post_data.appid = this.appid
      this.post(this.api_url + 'Agent/client',post_data,true).then((res)=>{
        if(res.status == 1){
          this.pageData = res.data;
          this.get_extension();
          console.log(this.$store.state.account.user)
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    get_extension(){
      var post_data = {}
      post_data.appid = this.appid
      this.post(this.api_url + 'Agent/extensions',post_data,true).then((res)=>{
        if(res.status == 1){
          this.extension_list = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    go_act(act_type){
      this.$router.push({name:'Activation',params:{rif: this.pageData.license_type + this.pageData.license, act_type: act_type, store:this.pageData.store}});
    },
    go_ext(extid){
      this.$router.push({name:'A_Extension',query:{extid: extid}});
    },
    get_it_confim(){
      this.$store.commit('setConfimBox',{type:'confim_exit',msg:'Revisaremos su solicitud y le notificaremos más tarde.',_this:this,focus:'',method:'get_it',arg1:''});
    },
    get_it(){
      var post_data = {}
      post_data.appid = this.appid
      this.post(this.api_url + 'Agent/os_ch_tec',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    go_lic(){
      var post_data = {};
      post_data.rif = this.pageData.license_type + this.pageData.license;
      post_data.store = this.pageData.store;
      this.post(this.api_url + 'Agent/lic_make',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.$router.back(-1);
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    ddd(){
      console.log('ddd');
    },
    change_tec(){
      this.is_change_tec = true;
    },
    change_tec_now(){
      var post_data = {};
      post_data.appid = this.appid;
      post_data.new_tec_username = this.new_tec;
      this.post(this.api_url + 'Agent/change_tec_now',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Éxito"});
          this.is_change_tec = false;
          this.get_pageData();
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    }
  },
  mounted() {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/Client.vue